(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('.pc-rating__link');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const reviews = document.getElementById('judgeme_product_reviews');
  if (!reviews) return;
  event.preventDefault();
  event.stopPropagation();
  reviews.setAttribute('tabindex', '-1');
  reviews.focus({ preventScroll: true });
  reviews.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-video-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pc-video-stories')) {
  customElements.define('pc-video-stories', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const track = this.querySelector('.pc-stories__track');
      const slides = [...track.children];
      const dots = [...this.querySelectorAll('.pc-stories__dots button')];
      let index = 0;
      const go = (next) => {
        const target = (next + slides.length) % slides.length;
        track.scrollTo({left:slides[target].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      this.querySelector('.pc-stories__arrow--prev')?.addEventListener('click',()=>go(index-1),options);
      this.querySelector('.pc-stories__arrow--next')?.addEventListener('click',()=>go(index+1),options);
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i),options));
      track.addEventListener('scroll',()=>{
        const next=Math.round(track.scrollLeft/(slides[0].getBoundingClientRect().width+16));
        if(next!==index){this.querySelectorAll('video').forEach(v=>v.pause());index=next;}
        dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
      },options);
      this.querySelectorAll('video').forEach(video=>{
        const play=video.parentElement.querySelector('.pc-stories__play');
        video.controls=false;play.hidden=false;
        play.addEventListener('click',()=>{video.controls=true;video.play().catch(()=>{video.controls=true;play.hidden=true;});},options);
        video.addEventListener('play',()=>{this.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});play.hidden=true;},options);
        video.addEventListener('pause',()=>{play.hidden=false;},options);
        video.addEventListener('ended',()=>{play.hidden=false;video.controls=false;},options);
      });
      document.addEventListener('shopify:block:select',event=>{
        const slide=event.target.closest('.pc-stories__slide');
        if(slides.includes(slide))go(slides.indexOf(slide));
      },options);
    }
    disconnectedCallback(){this.abort?.abort();this.querySelectorAll('video').forEach(v=>v.pause());}
  });
}

  } catch(e) { console.error(e); }
})();
})();
